export default "__VITE_ASSET__gaPK01nT__"